import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { LoginPage, InvoicePage, Waitlist, PreviewPage } from './pages';

const ProtectedRoute = ({ isAuthenticated, children }) => {
  return isAuthenticated ? children : <Navigate to="/" replace />;
};

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={<LoginPage setIsAuthenticated={setIsAuthenticated} />}
        />
        <Route
          path="/waitlist"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Waitlist />
            </ProtectedRoute>
          }
        />
        <Route
          path="/InvoicePage"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              < InvoicePage/>
            </ProtectedRoute>
          }
        />
        <Route
          path="/PreviewPage"
          element={
              < PreviewPage/>
          }
        />
        
      </Routes>
    </Router>
  );
};

export default App;
